import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	attachmentNotFound: {
		id: 'replyAttachmentPreview.attachmentNotFound',
		defaultMessage: 'Файл недоступен',
	},
});
